<div class="row m-t m-b">
  <div class="col-md-8 col-sm-12">
    <form
      *ngIf="resultsPageGrid && resultsPageGrid.filtersForm"
      #form="ngForm"
      [formGroup]="resultsPageGrid.filtersForm"
      class="form"
      novalidate
    >
      <div class="row search-container">
        <div class="col-4">
          <div class="search-box">
            <input type="search" class="form-search-box" formControlName="searchText" placeholder="Search User" />
            <i class="icon-search icon-xl"></i>
          </div>
        </div>
        <div class="col-4 position-relative">
          <div class="col me-4">
            <mat-select formControlName="role" placeholder="Filter By Role" class="form-control">
              <mat-option [value]="null">All Roles</mat-option>
              <mat-option *ngFor="let role of roles" [value]="role.role">
                {{ role.description }}
              </mat-option>
            </mat-select>
          </div>
          <button (click)="clearSelect('role')" class="clear">&times;</button>
        </div>
        <div class="col-4 position-relative">
          <div class="col me-4">
            <mat-select formControlName="privilege" placeholder="Filter By Privilege" class="form-control">
              <mat-option [value]="null">All Privileges</mat-option>
              <mat-option *ngFor="let privilege of privilegesList" [value]="privilege">
                {{ privilege }}
              </mat-option>
            </mat-select>
          </div>
          <button (click)="clearSelect('privilege')" class="clear">&times;</button>
        </div>
      </div>
    </form>
  </div>
  <div class="col-md-4 col-sm-12 text-right">
    <button class="" (click)="userModal('')">
      <span> <i class="icon-add-1 icon-xl float-left"></i> Add User</span>
    </button>
    <button class="btn-circle animate float-right" (click)="refreshGrid()">
      <span>
        <i class="fa fa-refresh m-0"></i>
      </span>
    </button>
  </div>
</div>

<!-- Loading Indicator -->
<div *ngIf="gridInProgress" class="d-flex justify-content-center p-3">
  <mat-spinner diameter="40"></mat-spinner>
</div>

<!-- Material Table -->
<div *ngIf="!gridInProgress && resultsPageGrid" class="stripe-table">
  <table mat-table [dataSource]="resultsPageGrid.dataSource" matSort class="mat-elevation-z1 mat-table mat-small clean-table">
    <!-- Profile Picture Column -->
    <ng-container matColumnDef="profilePic">
      <th mat-header-cell *matHeaderCellDef width="100px"></th>
      <td mat-cell *matCellDef="let element">
        <div class="pic-holder">
          <img class="profile-image" [src]="element?.avatarUrl || 'assets/images/default-profile-pic.png'" alt="" />
        </div>
      </td>
    </ng-container>

    <!-- User Info Column -->
    <ng-container matColumnDef="userInfo">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>User</th>
      <td mat-cell *matCellDef="let element">
        <div>
          <span class="first-name text-capitalize">
            <b
              >{{ (element?.firstName && element?.firstName.toLowerCase()) || '' }}
              {{ (element?.lastName && element?.lastName.toLowerCase()) || '' }}</b
            >
          </span>
        </div>
        <div class="item4">
          <span class="designation">
            <b>{{ element?.designation || '' }}</b>
          </span>
        </div>
        <div class="item5">
          <span class="email">{{ element?.email || '' }}</span>
        </div>
      </td>
    </ng-container>

    <!-- Role Column -->
    <ng-container matColumnDef="role">
      <th mat-header-cell *matHeaderCellDef>Role</th>
      <td mat-cell *matCellDef="let element">
        <div>
          <span *ngFor="let role of element?.roles; let i = index" class="sq-box">
            <span>{{ userRoles[role][0].description }}</span>
          </span>
        </div>
      </td>
    </ng-container>

    <!-- Actions Column -->
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef class="text-center">Actions</th>
      <td mat-cell *matCellDef="let element" class="text-center">
        <span class="btn-icon btn-edit btn-popups" *ngIf="element?.active" (click)="userModal(element)">
          <i class="fa fa-pencil" alt="edit"></i>
          <span>Edit</span>
        </span>
        <span class="btn-icon btn-disabled" *ngIf="!element?.active">
          <i class="fa fa-pencil"></i>
        </span>
        <span class="btn-icon btn-download btn-popups" *ngIf="element?.active" (click)="resetPassword(element)">
          <i class="fa fa-sync"></i>
          <span>Reset Password</span>
        </span>
        <span class="btn-icon btn-disabled" *ngIf="!element?.active">
          <i class="fa fa-sync"></i>
        </span>
        <span class="btn-icon btn-remove btn-popups" (click)="deleteUser(element)">
          <i class="fa fa-trash"></i>
          <span>Delete</span>
        </span>
        <button
          [disabled]="!element?.blocked"
          class="user-disabled-btn icon-change btn-circle no-fill ws-loading
          {{ element?.blockInProgress ? 'ws-loading-progress' : '' }}
           {{ element?.blocked ? 'btn-user-blocked' : 'btn-inactive blocked' }}"
          (click)="unblockUser(element)"
        >
          <i class="fa-solid fa-user-lock btn-icon icon-xl-blocked {{ element?.blocked ? '' : 'btn-inactive' }}"></i>
        </button>
      </td>
    </ng-container>

    <!-- Status Column -->
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef class="text-center">Status</th>
      <td mat-cell *matCellDef="let element" class="text-center">
        <span class="btn-icon btn-popups act-inact" (click)="activate(element)">
          <i
            [hidden]="!element?.active"
            class="fa fa-check"
            [ngClass]="{ 'btn-active': element?.active, 'btn-inactive': !element?.active }"
          >
            <span>Active</span>
          </i>
          <i
            [hidden]="element?.active"
            class="fa fa-user-lock"
            [ngClass]="{ 'btn-active': element?.active, 'btn-inactive': !element?.active }"
          >
            <span>Inactive</span>
          </i>
        </span>
      </td>
    </ng-container>

    <!-- Mobile View Column (hidden on desktop) -->
    <ng-container matColumnDef="mobileView">
      <th mat-header-cell *matHeaderCellDef class="d-md-none">User Actions</th>
      <td mat-cell *matCellDef="let element" class="d-md-none">
        <div>
          <span class="first-name text-capitalize">
            <b
              >{{ (element?.firstName && element?.firstName.toLowerCase()) || '' }}
              {{ (element?.lastName && element?.lastName.toLowerCase()) || '' }}</b
            >
          </span>
        </div>
        <div class="item4">
          <span class="designation">
            <b>{{ element?.designation || '' }}</b>
          </span>
        </div>
        <div class="item5">
          <span class="email">{{ element?.email || '' }}</span>
        </div>
        <div class="item6 clearfix m-b">
          <span *ngFor="let role of element?.roles; let i = index" class="sq-box">
            <span>{{ userRoles[role][0].description }}</span>
          </span>
        </div>
        <div class="item7">
          <span class="btn-icon btn-edit btn-popups" *ngIf="element?.active" (click)="userModal(element)">
            <i class="fa fa-pencil" alt="edit"></i>
            <span>Edit</span>
          </span>
          <span class="btn-icon btn-disabled" *ngIf="!element?.active">
            <i class="fa fa-pencil"></i>
          </span>
          <span class="btn-icon btn-download btn-popups" *ngIf="element?.active" (click)="resetPassword(element)">
            <i class="fa fa-sync"></i>
            <span>Reset Password</span>
          </span>
          <span class="btn-icon btn-disabled" *ngIf="!element?.active">
            <i class="fa fa-sync"></i>
          </span>
          <span class="btn-icon btn-remove btn-popups" (click)="deleteUser(element)">
            <i class="fa fa-trash"></i>
            <span>Delete</span>
          </span>
          <span class="btn-icon btn-popups act-inact" (click)="activate(element)">
            <i
              [hidden]="!element?.active"
              class="fa fa-check"
              [ngClass]="{ 'btn-active': element?.active, 'btn-inactive': !element?.active }"
            >
              <span>Active</span>
            </i>
            <i
              [hidden]="element?.active"
              class="fa fa-user-lock"
              [ngClass]="{ 'btn-active': element?.active, 'btn-inactive': !element?.active }"
            >
              <span>Inactive</span>
            </i>
          </span>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns" [ngClass]="'d-none d-md-table-row'"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" [ngClass]="'d-none d-md-table-row'"></tr>

    <!-- Mobile rows -->
    <tr mat-header-row *matHeaderRowDef="mobileColumns" class="d-md-none"></tr>
    <tr mat-row *matRowDef="let row; columns: mobileColumns" class="d-md-none" [class]="rowCallback({ dataItem: row, index: 0 })"></tr>
  </table>

  <!-- No Data Message -->
  <div *ngIf="!gridInProgress && resultsPageGrid && resultsPageGrid.dataSource.data.length === 0" class="text-center p-4">
    <p class="text-muted">No records found</p>
  </div>

  <!-- Paginator -->
  <mat-paginator
    [pageSizeOptions]="[15, 25, 50, 100]"
    [pageSize]="resultsPageGrid.pageSize"
    [length]="resultsPageGrid.total"
    [pageIndex]="resultsPageGrid.pageIndex"
    (page)="resultsPageGrid.onPaginate($event)"
    showFirstLastButtons
  >
  </mat-paginator>
</div>
